import { useState } from "react";
import { Link } from "react-router-dom";
import { CONTEST_RULES_SECTIONS } from "constants/contestRulesContent";

export default function ContestRulesModal({ onAccept }) {
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");

  function handleAccept() {
    if (!accepted) {
      setError("Please read and accept the contest rules to continue.");
      return;
    }
    setError("");
    onAccept();
  }

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 px-4 py-8"
      role="presentation"
    >
      <div
        className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-2xl dark:border-white/10 dark:bg-navy-800"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contest-rules-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-gray-100 px-6 py-5 dark:border-white/10">
          <h2
            id="contest-rules-title"
            className="text-xl font-bold text-navy-700 dark:text-white"
          >
            Referral contest rules
          </h2>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Please read and accept these rules before participating. This step is required
            the first time you open Contest.
          </p>
        </div>

        <div className="flex-1 space-y-5 overflow-y-auto px-6 py-5">
          {CONTEST_RULES_SECTIONS.map((section) => (
            <section key={section.title}>
              <h3 className="text-sm font-bold uppercase tracking-wide text-brand-500 dark:text-brand-300">
                {section.title}
              </h3>
              <div className="mt-2 space-y-2 text-sm leading-relaxed text-gray-600 dark:text-gray-300">
                {section.paragraphs.map((paragraph) => (
                  <p key={paragraph.slice(0, 48)}>{paragraph}</p>
                ))}
              </div>
            </section>
          ))}
          <p className="text-sm text-gray-500 dark:text-gray-400">
            Full public rules:{" "}
            <Link
              to="/Contest/RefferalContest"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-brand-500 hover:text-brand-600 dark:text-brand-300"
            >
              Contest / ReferralContest
            </Link>
          </p>
        </div>

        <div className="border-t border-gray-100 px-6 py-4 dark:border-white/10">
          <label className="flex cursor-pointer items-start gap-3">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => {
                setAccepted(e.target.checked);
                if (e.target.checked) setError("");
              }}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-400 dark:border-white/20 dark:bg-navy-900"
            />
            <span className="text-sm text-gray-700 dark:text-gray-200">
              I have read and accept the referral contest rules. I understand that prizes
              require Path 1 (broker partner) and that AlphaSniper may disqualify fraudulent
              participation.
            </span>
          </label>

          {error ? (
            <p className="mt-3 text-sm text-amber-700 dark:text-amber-300">{error}</p>
          ) : null}

          <div className="mt-4 flex flex-wrap justify-end gap-3">
            <Link
              to="/client/dashboard"
              className="rounded-xl border border-gray-200 px-4 py-2.5 text-sm font-semibold text-gray-600 transition hover:bg-gray-50 dark:border-white/15 dark:text-gray-300 dark:hover:bg-white/5"
            >
              Back to dashboard
            </Link>
            <button
              type="button"
              onClick={handleAccept}
              className="rounded-xl bg-brand-500 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-600"
            >
              I accept — continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
